export enum ContractType {
  BANKING_PRODUCT = 'Produit bancaire',
  INSURANCE = 'Assurance',
}

export const CONTRACT_TYPE: Record<ContractType, string> = {
  [ContractType.BANKING_PRODUCT]: 'BANCAIRE',
  [ContractType.INSURANCE]: 'ASSURANCE',
};
